import { ApiModule, type PaginatedResponseData } from '@common/index';
import type { EducationMonthItem, EducationMonth, EducationMonthValidate } from '../models';

export class EducationMonthApi extends ApiModule {
  protected endpoint = '/education-month';

  public async pageEducationMonths(params: any) {
    return this.api.post<PaginatedResponseData<EducationMonthItem>, any>(
      `${this.endpoint}/page?page=${params.page}&size=${params.itemsPerPage}&sort=monthDate,desc`,
      {
        ...params
      }
    );
  }

  public loadEducationMonthDetails(id: number) {
    return this.api.get<EducationMonth>(`${this.endpoint}?id=${id}`);
  }

  public saveEducationMonth(params: any) {
    return this.api.post(`${this.endpoint}`, {
      ...params
    });
  }

  public deleteEducationMonth(id: number) {
    return this.api.delete(`${this.endpoint}?id=${id}`);
  }

  public copyEducationMonth(id: number): Promise<any> {
    return this.api.post(`${this.endpoint}/copy?id=${id}`);
  }
  public closeReportsInMonth(id: number): Promise<any> {
    return this.api.post(`${this.endpoint}/close?id=${id}`);
  }

  public validateMonth(params: any) {
    return this.api.get<EducationMonthValidate>(`${this.endpoint}/validate-month`, { params });
  }
}
